(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoRelevanteDetailController', OrganoRelevanteDetailController);

    OrganoRelevanteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OrganoRelevante', 'Norma', 'Organo'];

    function OrganoRelevanteDetailController($scope, $rootScope, $stateParams, previousState, entity, OrganoRelevante, Norma, Organo) {
        var vm = this;

        vm.organoRelevante = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:organoRelevanteUpdate', function(event, result) {
            vm.organoRelevante = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
